module.exports = __webpack_public_path__ + "static/img/运营.74d9b0bd.png";